import { render, staticRenderFns } from "./PortfolioPositions.vue?vue&type=template&id=b4347e76"
import script from "./PortfolioPositions.vue?vue&type=script&lang=js"
export * from "./PortfolioPositions.vue?vue&type=script&lang=js"
import style0 from "./PortfolioPositions.vue?vue&type=style&index=0&id=b4347e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports